import { render, staticRenderFns } from "./MyCompanyUsersResetPass.vue?vue&type=template&id=5bd4f8ac&scoped=true&"
import script from "./MyCompanyUsersResetPass.vue?vue&type=script&lang=js&"
export * from "./MyCompanyUsersResetPass.vue?vue&type=script&lang=js&"
import style0 from "./MyCompanyUsersResetPass.vue?vue&type=style&index=0&id=5bd4f8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4f8ac",
  null
  
)

export default component.exports